import { render } from "./CurrentSetScore.vue?vue&type=template&id=8be4b38c&scoped=true"
import script from "./CurrentSetScore.vue?vue&type=script&lang=js"
export * from "./CurrentSetScore.vue?vue&type=script&lang=js"

import "./CurrentSetScore.vue?vue&type=style&index=0&id=8be4b38c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8be4b38c"]])

export default __exports__